/**
 * Hook into Alpine so that it is available no matter at which point Alpine loads.
 */
document.addEventListener('alpine:init', () => {
    /**
     * Object to manage the access to the Government ID input for edit related on the Government ID Type.
     *
     * @property {string} governmentId the Government ID value
     * @property {boolean} governmentIdReadOnly is the Government ID read-only
     * @property {string} govIdElementId the DOM identifier of Government ID element
     * @property {string} govIdTypeId the DOM identifier of Government ID Type element
     * @property {array} typeNoValues the values of not selected Government ID
     */
    Alpine.data('identifiersGovernmentId', (governmentId, governmentIdType, governmentIdReadOnly, govIdElementId, govIdTypeId, typeNoValues) => ({
        governmentId: governmentId,
        governmentIdType: governmentIdType,
        governmentIdReadOnly: governmentIdReadOnly,
        govIdElementId: govIdElementId,
        govIdTypeId: govIdTypeId,
        typeNoValues: typeNoValues,
        noGovernmentId: false,


        /**
         * Run on intialization of the alpine data.
         */
        init() {
            this.noGovernmentId = this.hasNoValueType(this.governmentIdType);
            this.$el.addEventListener(`input-changed-${this.govIdTypeId.toLowerCase()}`, this.changed.bind(this));
        },

        /**
         * Government ID Type changes handler.
         *
         * @param $event
         */
        changed($event) {
            this.noGovernmentId = this.hasNoValueType($event.detail);
            if (this.noGovernmentId && !this.governmentIdReadOnly) {
                this.governmentId = '';
            }
        },

        /**
         * Check does the Government ID Type has the type value.
         *
         * @param value
         * @return {*}
         */
        hasNoValueType: function(value) {
            return this.typeNoValues.includes(value);
        }
    }));
});